export const localStorageKeys = {
  TOKEN: "token",
  MY_INFO: "my_info",
};
